"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptExecutionError = exports.ScriptTimeoutError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../common/localizeUtils");
const types_1 = require("./types");
/**
 * Script execution timeout
 */
class ScriptTimeoutError extends teamsfx_api_1.UserError {
    constructor(cmd, error) {
        const key = "error.script.ScriptTimeoutError";
        const errorOptions = {
            source: "script",
            name: "ScriptTimeoutError",
            message: localizeUtils_1.getDefaultString(key, cmd),
            displayMessage: localizeUtils_1.getLocalizedString(key, cmd),
            error: error,
            categories: [types_1.ErrorCategory.External],
        };
        super(errorOptions);
    }
}
exports.ScriptTimeoutError = ScriptTimeoutError;
/**
 * Script execution error
 */
class ScriptExecutionError extends teamsfx_api_1.UserError {
    constructor(script, message, error) {
        const key = "error.script.ScriptExecutionError";
        const errorOptions = {
            source: "script",
            name: "ScriptExecutionError",
            message: localizeUtils_1.getDefaultString(key, script, message),
            displayMessage: localizeUtils_1.getLocalizedString(key, script, message),
            error: error,
            categories: [types_1.ErrorCategory.External],
        };
        super(errorOptions);
    }
}
exports.ScriptExecutionError = ScriptExecutionError;
//# sourceMappingURL=script.js.map